import { useState } from 'react';
import { useLanguage } from '../../../contexts/language/LanguageContext';
import { useOrientation } from '../../../hooks/useOrientation';
import { VIDEO_PATHS } from '../../../helpers/constants.helper';
import Skeleton from '../../../components/skeleton/Skeleton';
import './VideoSection.scss';

const VideoSection = () => {
  const { t } = useLanguage();
  const [videoLoaded, setVideoLoaded] = useState(false);
  const isPortrait = useOrientation();

  const handleVideoLoad = () => {
    setVideoLoaded(true);
  };

  const handleScrollClick = () => {
    // Trigger scroll down by dispatching a wheel event
    const event = new WheelEvent('wheel', {
      deltaY: 100,
      bubbles: true,
      cancelable: true
    });
    window.dispatchEvent(event);
  };

  const videoSrc = isPortrait ? VIDEO_PATHS.PORTRAIT : VIDEO_PATHS.LANDSCAPE;

  return (
    <section className={`video-section ${videoLoaded ? 'video-loaded' : ''}`}>
      <div className="video-section__video-container">
        {!videoLoaded && (
          <div className="video-section__skeleton">
            <Skeleton variant="hero" width="100%" height="100vh" />
          </div>
        )}
        <video
          key={videoSrc}
          className="video-section__video"
          src={videoSrc}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          disablePictureInPicture
          onLoadedData={handleVideoLoad}
          style={{ opacity: videoLoaded ? 1 : 0 }}
        />
      </div>

      <div className="video-section__overlay">
        <div className="video-section__content">
          <h1 className="video-section__logo">
            ALINA POLONEYEVA
          </h1>
          <p className="video-section__subtitle">
            {t.hero.subtitle}
          </p>
        </div>
      </div>

      {/* Scroll Indicator - always visible */}
      <button
        className="video-section__scroll-indicator"
        onClick={handleScrollClick}
        aria-label="Scroll to next section"
      >
        <div className="scroll-indicator__arrow"></div>
      </button>
    </section>
  );
};

export default VideoSection;
